import { useContext, useEffect } from "react";
import { CollapsibleListItemContext } from "../../CollapsibleList/CollapsibleList";

export const ActionBarSpaceBetween = (): null => {
	const {
		onResponsiveBehaviorChange,
		onIsSpaceBetweenChange,
		resetIsSpaceBetween,
		resetResponsiveBehavior
	} = useContext(CollapsibleListItemContext);

	useEffect(
		() => {
			onResponsiveBehaviorChange("always-visible");
			onIsSpaceBetweenChange(true);

			return (): void => {
				resetResponsiveBehavior();
				resetIsSpaceBetween();
			};
		},
		[
			onResponsiveBehaviorChange,
			onIsSpaceBetweenChange,
			resetResponsiveBehavior,
			resetIsSpaceBetween
		]
	);

	return null;
};

ActionBarSpaceBetween.displayName = "ActionBarSpaceBetween";
